import { prop } from 'ramda'

import type { ExternalServiceSettings, Params } from 'app/dataTypes/vending/machine/externalServices'

import type { Request } from '../../../../index'

type UrlParams = {
  machineId: number,
}
export const convertParams = (params: Params): [null, UrlParams] => {
  const { machineId } = params
  return [null,
    {
      machineId
    }]
}

type ExternalServiceSettingsApi = {
  active: boolean
}

type ApiResult = {
  result: 'success'
  meta: {}
  data: {
    enable_vending_external_services: boolean
    services: {
      [serviceId in string]: ExternalServiceSettingsApi
    }
  }
}


export const convertResult = (data: ApiResult): ExternalServiceSettings => {
  const items = prop('data', data) || {}
  const { enable_vending_external_services: enableExternalServices, services } = items
  const serviceIds = Object.keys(services)
  return {
    enableExternalServices,
    services: serviceIds.map(id => ({
      serviceId: id,
      active: services[id].active
    }))
  }
}

export const GET_VENDING_MACHINES_EXTERNAL_SERVICES_SETTINGS: Request<Params, ExternalServiceSettings, UrlParams> = [
  'data/vending/machines/{machineId}/external_services_settings',
  'get',
  ['data'],
]
